import { useMemo } from 'react'
import { array, mixed, number, Schema, string } from 'yup'

import { useFormStrings } from '../formContext'

type Type = 'list' | 'number' | 'text' | 'email'

export interface ValidationProps {
  type?: Type
  required?: boolean
  schema?: Schema
}

export function useSchema(schemaDef: ValidationProps) {
  const { type, required, schema } = schemaDef
  const messages = useFormStrings().validation
  return useMemo(
    () => {
      if (schema) return schema
      if (!type && !required) return null

      if (required) {
        if (type === 'list') {
          return array().required(value => Array.isArray(value)
            ? messages.requiredList
            : messages.required,
          ).min(1, messages.requiredList)
        }
        return baseValidator(type).required(messages.required)
      }
      return baseValidator(type).nullable()
    },
    [type, required, schema, messages.required, messages.requiredList],
  )
}

function baseValidator(type?: Type) {
  switch (type) {
    case 'list':
      return array()
    case 'number':
      return number()
    case 'email':
      return string().email()
    case 'text':
      return string()
    default:
      return mixed()
  }
}
